import * as React from 'react';
import { connect } from 'react-redux';
import { Sidebar } from '../components';
import { IComponent, EComponentTypes, IProperty, ComponentHelper, IJESettingsSidebar, EConfirmationOperationType, AdminToolHelper, AdminToolPanelHelper } from '../helpers';
import { CONTROL_BLOCK_LOOPING_PROPERTIES } from '../constants';
import store from '../store/store';
import types from '../store/types';
import { JESettingsSidebar } from '../components/layout/jesettings-sidebar';
import { JourneyEngineSettingsHelper } from '../helpers/journeyenginesettingshelper';

interface IProps {
    panelName?: string;
}
class JESettingsSidebarContainer extends React.Component<any, IProps, any> {

    getPropertiesToExclude = (component: IComponent): string[] => {

        let propertiesToExclude: string[] = [];

        if (!!component && !!component.ComponentType) {

            if (component.ComponentType.ComponentTypeId === EComponentTypes.block) {
                propertiesToExclude = CONTROL_BLOCK_LOOPING_PROPERTIES;
                // if (this.props.navigationMode === "paged") {
                propertiesToExclude.push("Save Label", "Edit Label", "Cancel Label");
                // }
            }
            else {
                propertiesToExclude = ComponentHelper.getProperties(component).filter(p => !p.IsPrimary).map(p => p.Name);
            }

        }

        return propertiesToExclude;
    }

    updateJourneyEngineSettingsList = (key: string, value: any) => {
        store.dispatch({
            type: types.SET_JESETTINGS_SIDEBAR_PROPERTY,
            jesettingPropertyKey: key,
            jesettingPropertyValue: value
        });
    }


    deleteJESetting = () => {

        let feedbackAlert: boolean = confirm("Are you sure you want to delete this record?");
        if (feedbackAlert) {
            // Remove je setting
            JourneyEngineSettingsHelper.removeFromJESettingsList(this.props.panelName, this.props.state.jesetting.journeyEngineSettingsId).then(() => {
            })

            let sidebar: IJESettingsSidebar = { isOpen: false, type: "new", jesetting: null, isSuccess: false, formValidationError: [], error: null };
            store.dispatch({
                type: types.SET_JESETTINGS_SIDEBAR,
                sidebar: sidebar,
            });
        }

    }

    close = (save?: boolean, isCreate?: boolean) => {
        if (save) {
            let isFormValid = JourneyEngineSettingsHelper.validateSidebarForm(this.props.state.jesetting);
            if (isFormValid) {
                if (isCreate) {
                    JourneyEngineSettingsHelper.addToJESettingsList(this.props.panelName, this.props.state.jesetting).then(() => {
                    })
                } else {
                    JourneyEngineSettingsHelper.updateFromJESettingsList(this.props.panelName, this.props.state.jesetting).then(() => {
                    })
                }
            }
        } else {
            let sidebar: IJESettingsSidebar = { isOpen: false, type: "new", jesetting: null, isSuccess: false, formValidationError: [], error: null };
            store.dispatch({
                type: types.SET_JESETTINGS_SIDEBAR,
                sidebar: sidebar,
            });
        }
    }


    public render() {

        // let component: IComponent = this.props.components[this.props.state.componentId];
        // let propertiesToExclude = this.getPropertiesToExclude(component);

        return (
            <JESettingsSidebar
                toggle={toggle}
                togglePin={togglePin}
                updateJourneyEngineSettingsList={this.updateJourneyEngineSettingsList}
                component={null}
                propertiesToExclude={null}
                sidebar={this.props.state}
                close={this.close}
                deleteJESetting={this.deleteJESetting}
                {...this.props.state}
            />
        );
    }

};

let togglePin = () => {
    store.dispatch({ type: types.TOGGLE_SIDEBAR_PIN });
};

let toggle = () => {
    let sidebar: IJESettingsSidebar = { isOpen: false, type: "new", jesetting: null, isSuccess: false, formValidationError: [], error: null };
    store.dispatch({
        type: types.SET_JESETTINGS_SIDEBAR,
        sidebar: sidebar,
    });


};

let mapStateToProps = (store) => {

    //   let navigationModeProperty: IProperty = store.toolsState.Properties.filter(p => p.Name === "Default Navigation Mode")[0]
    return {
        state: store.adminToolState.sidebar,
        // components: store.processState.components,
        // navigationMode: navigationModeProperty ? navigationModeProperty.Value : null
    };
};

export default connect<any, any, any>(mapStateToProps)(JESettingsSidebarContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/jesettings-sidebar.tsx